import { useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'

import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import { DiaryForm } from './components/DiaryForm'
import type { Breadcrumb } from '@/types/shared'
import type { DiaryFormData, DiaryFormOptions } from './types'

type Props = {
  diary: DiaryFormData
  options: DiaryFormOptions
  breadcrumbs: Breadcrumb[]
}

export default function New({ diary, options, breadcrumbs }: Props) {
  const { data, setData, errors, processing, post, transform } = useForm({
    diary_date: diary.diaryDate || new Date().toISOString().split('T')[0],
    activity_type: diary.activityType || '',
    concentration_rating: diary.concentrationRating?.toString() || '',
    attitude_rating: diary.attitudeRating?.toString() || '',
    understanding_rating: diary.understandingRating?.toString() || '',
    challenge_rating: diary.challengeRating?.toString() || '',
    continuity_rating: diary.continuityRating?.toString() || '',
    reflection: diary.reflection || '',
    training_content_ids: diary.trainingContentIds || [],
    diary_theme_ids: diary.diaryThemeIds || [],
  })

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    transform((current) => ({ soccer_diary: current }))
    post('/player/soccer_diaries')
  }

  return (
    <AppShell>
      <PageHeader
        title="日記を書く"
        description="今日の練習・試合を振り返りましょう"
        breadcrumbs={breadcrumbs}
      />

      <DiaryForm
        data={data}
        setData={setData}
        errors={errors}
        processing={processing}
        options={options}
        onSubmit={handleSubmit}
        submitLabel="保存する"
        cancelHref="/player/soccer_diaries"
      />
    </AppShell>
  )
}
